// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__95fCO","filesListContainer":"PosDisputesFiles_filesListContainer__3_Fxr","filesButton":"PosDisputesFiles_filesButton__XcfY9"};